import {Component, DoCheck, EventEmitter, Inject, Input, IterableDiffer, IterableDiffers, Output} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PropertyValue} from '@domain/property-value';
import {TechnicalDatasheet} from '@domain/technical-datasheet/technical-datasheet';
import {TechnicalDatasheets, TECHNICAL_DATASHEETS} from '@infrastructure/http/technical-datasheets/technical-datasheets';
import {BaseComponent} from '@vdw/angular-component-library';
import {isEmpty} from 'lodash-es';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-technical-datasheet-thumbnails',
  templateUrl: './technical-datasheet-thumbnails.component.html',
  styleUrls: ['./technical-datasheet-thumbnails.component.scss']
})
export class TechnicalDatasheetThumbnailsComponent extends BaseComponent implements DoCheck {
  @Input() public advancedSearchFilters: PropertyValue[] = [];
  @Input() public selectedTechnicalDatasheet: TechnicalDatasheet;
  @Output() public selectedTechnicalDatasheetChange: EventEmitter<TechnicalDatasheet> = new EventEmitter<TechnicalDatasheet>();

  public listOfTechnicalDatasheets: TechnicalDatasheet[] = [];
  public technicalDatasheetsHaveBeenLoaded = false;

  private canGetMoreTechnicalDatasheets = false;
  private uniqueTechnicalDatasheetsCount = 0;
  private hasLoadedTechnicalDatasheetForTheFirstTime = false;
  private readonly SLICE_LENGTH = 150;
  private readonly iterableDiffer: IterableDiffer<any>;

  public constructor(
    @Inject(TECHNICAL_DATASHEETS) private readonly technicalDatasheets: TechnicalDatasheets,
    private readonly activatedRoute: ActivatedRoute,
    iterableDiffers: IterableDiffers
  ) {
    super();
    this.technicalDatasheets = technicalDatasheets;
    this.iterableDiffer = iterableDiffers
      .find([])
      .create((index: number, advancedSearchFilter: PropertyValue): string => `${advancedSearchFilter.propertyName}_${advancedSearchFilter.propertyValue?.id ?? advancedSearchFilter.propertyValue}`);
  }

  public ngDoCheck(): void {
    const changes = this.iterableDiffer.diff(this.advancedSearchFilters);
    if (changes) {
      this.technicalDatasheetsHaveBeenLoaded = false;
      this.uniqueTechnicalDatasheetsCount = 0;
      this.listOfTechnicalDatasheets = [];
      this.getTechnicalDatasheets();
    }
  }

  public hasTechnicalDatasheets(): boolean {
    return !isEmpty(this.listOfTechnicalDatasheets);
  }

  public onVirtualScrollerEnd(): void {
    if (this.canGetMoreTechnicalDatasheets) {
      this.canGetMoreTechnicalDatasheets = false;
      this.getTechnicalDatasheets();
    }
  }

  public onSelectedTechnicalDatasheetChange(technicalDatasheet: TechnicalDatasheet): void {
    this.selectedTechnicalDatasheetChange.emit(technicalDatasheet);
  }

  private getTechnicalDatasheets(): void {
    this.technicalDatasheets
      .get(this.uniqueTechnicalDatasheetsCount, this.SLICE_LENGTH, this.advancedSearchFilters)
      .pipe(takeUntil(this.unSubscribeOnViewDestroy))
      .subscribe((technicalDatasheets: TechnicalDatasheet[]) => {
        const technicalDatasheetsAmount = technicalDatasheets.length;
        this.listOfTechnicalDatasheets = technicalDatasheets;
        this.technicalDatasheetsHaveBeenLoaded = true;
        this.uniqueTechnicalDatasheetsCount += technicalDatasheetsAmount;
        this.canGetMoreTechnicalDatasheets = technicalDatasheetsAmount === this.SLICE_LENGTH;

        const technicalDatasheetId = this.activatedRoute.snapshot.params.id;

        if (!!technicalDatasheetId && !this.hasLoadedTechnicalDatasheetForTheFirstTime) {
          this.selectedTechnicalDatasheetChange.emit(this.listOfTechnicalDatasheets.find((technicalDatasheet: TechnicalDatasheet) => technicalDatasheet.id === Number(technicalDatasheetId)));
        }

        this.hasLoadedTechnicalDatasheetForTheFirstTime = true;
      });
  }
}
